var QUESTION_TYPE = {
    MULTIPLE: "Modules\\Questionnaire\\Entities\\MultipleChoiceQuestion",
    BOOLEAN:  "Modules\\Questionnaire\\Entities\\BoolQuestion",
    QUANTITY: "Modules\\Questionnaire\\Entities\\QuantityQuestion",
}

var STATUS = {

    NEW : 0,
    BOOKING_PENDING : 10,
    BOOKING_SIGNING : 15,
    BOOKING_COMPLETE : 19,
    PRELIMINARY_PENDING : 20,
    PRELIMINARY_SIGNING : 25,
    PRELIMINARY_COMPLETE : 29,
    EARLY_CHOICES_PENDING : 30,
    EARLY_CHOICES_SIGNING : 35,
    EARLY_CHOICES_COMPLETE : 39,
    DESIGN_CHOICES_PENDING : 40,
    DESIGN_CHOICES_SIGNING : 45,
    DESIGN_CHOICES_COMPLETE : 49,
    TENANCY_PENDING : 50,
    TENANCY_SIGNING : 55,
    TENANCY_COMPLETE : 59,
    TRANSFER_PENDING : 60,
    TRANSFER_SIGNING : 65,
    TRANSFER_COMPLETE : 69,
    SETTLEMENT_PENDING : 70,
    SETTLEMENT_SIGNING : 75,
    SETTLEMENT_COMPLETE : 79,
    COMPLETED : 100,
}

var CONFIGURATION_TYPE = {
    EARLY_CHOICES:  10,
    DESIGN_CHOICES: 20,
}
